/* eslint-disable */
import config from './config'
import { IMMessageToJSON } from '@/store/modules/call-center/convert'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import {
  Message
} from 'element-ui'
let _cube_uid
let promiseInstance // im 实例化，得到Promise
const webim = window.webim
const LOG_NAME = '[TXIM LOG]'

const ACTION_TYPE = {
  Notification: 'Notification',
  Chat: 'Chat',
  ChatMessage: 'CC.ChatMessage'
}

const MESSAGE_TYPE = {
  Timeout: 'Timeout',
  CreateSession: 'CreateSession',
  Text: 'text',
  Image: 'image',
  Voice: 'voice',
  Video: 'video'
}

const eventHub = new Vue()
const EVENT_TYPE = {
  MSG: 'MSG',
  NOTIFY: 'NOTIFY',
  KICKOFF: 'KICKOFF',
  CONNECTRET: 'CONNECTRET',
  RECONNECT: 'RECONNECT',
  UNKNOWN: 'UNKNOWN',
  LOGOUT: 'LOGOUT',
  LOGIN: 'LOGIN',
  USER_TRY_LOGIN: 'USER_TRY_LOGIN'
}

/**
 * ===================== 腾讯IM 调用封装类 =======================
 * @type {{listeners, options, LOGIN_INFO}}
 */
const TX = (() => {
  // Configuration
  const APPID = config.IM.APPID
  const ACCOUNTTYPE = config.IM.ACCOUNTTYPE
  const isLogOn = config.IM.isLogOn

  const messageDispatcher = (newMsg) => {
    // newMsg.toAccount = _engineer_code
    if (!newMsg.elems) {
      return null
    }

    for (let i = 0; i < newMsg.elems.length; i++) {
      const data = newMsg.elems[i]
      if (data.type !== webim.MSG_ELEMENT_TYPE.TEXT) {
        alert('IM发给了我们未知的消息类型')
        return null
      }

      // data.type === webim.MSG_ELEMENT_TYPE.TEXT
      // 接到消息之后，在IMMessageToJSON 中做第一次的字符串转译，让接下来的流程里正确识别表情等符号
      const msg = IMMessageToJSON(data.content.text)
      if (newMsg.fromAccount === 'remind') {
        msg.MessageBody.ClientType = 'robot'
      }
      console.log('收到Im消息', msg)
      // const actionType = msg.chat_type
      // const type = msg.message_type
      // 消息大类型 chat、notice、robot、createSession 等
      // 每条消息类型 text/image/voice/video
      eventHub.$emit(msg.MessageType === ACTION_TYPE.ChatMessage ? EVENT_TYPE.MSG : EVENT_TYPE.NOTIFY, msg)
    }

    webim.setAutoRead(newMsg.getSession(), true, true)
  }

  // 监听新消息事件
  // newMsgList 为新消息数组，结构为[Msg]
  function onMsgNotify(newMsgList) {
    if (!newMsgList) {
      return
    }
    newMsgList.map(messageDispatcher)
    webim.setAutoRead(newMsgList[0].getSession(), true, false)
  }

  // 监听连接状态回调变化事件
  function onConnNotify(resp) {
    switch (resp.ErrorCode) {
      case webim.CONNECTION_STATUS.ON:
        eventHub.$emit(EVENT_TYPE.CONNECTRET)
        return
      case webim.CONNECTION_STATUS.OFF:
        eventHub.$emit(EVENT_TYPE.RECONNECT, 'AppChat连接已断开,请检查网络连接')
        break
      case webim.CONNECTION_STATUS.RECONNECT:
        eventHub.$emit(EVENT_TYPE.CONNECTRET)
        break
      default:
        eventHub.$emit(EVENT_TYPE.UNKNOWN)
        break
    }
  }

  // 被其他登录实例踢下线
  function onKickedEventCall(e) {
    eventHub.$emit(EVENT_TYPE.KICKOFF, e)
  }

  return {
    listeners: {
      onConnNotify, onMsgNotify, onKickedEventCall
    },
    options: {
      'isAccessFormalEnv': true, // 是否访问正式环境，默认访问正式，选填
      isLogOn // 是否开启控制台打印日志,默认开启，选填
    },
    LOGIN_INFO: {
      'sdkAppID': APPID, // 用户所属应用id,必填
      'accountType': ACCOUNTTYPE, // 用户所属应用帐号类型，必填
      'identifier': null, // 当前用户ID,必须是否字符串类型，必填
      'identifierNick': null, // 当前用户昵称，选填
      'userSig': null, // 当前用户身份凭证，必须是字符串类型，必填
      'headurl': 'img/2016.gif' // 当前用户默认头像，选填
    }
  }
})()

/**
 * 登录腾讯云IM
 * @param user_code
 * @param userSig
 * @return {*}
 */
function getInstance(user_code, userSig) {
  if (promiseInstance) {
    return promiseInstance
  }
  const info = Object.assign({}, TX.LOGIN_INFO, {
    identifier: user_code,
    identifierNick: user_code,
    userSig
  })
  _cube_uid = user_code
  promiseInstance = new Promise((resolve, reject) => {
    // IMSDK登录
    webim.login(
      info, TX.listeners, TX.options,
      (resp) => {
        console.log(resp)
        info.identifierNick = resp.identifierNick
        resolve(txim)
      }, error => {
        // VueCookies.remove('Sign')
        // VueCookies.remove('cube_uid')
        // VueCookies.remove('token')
        // Message({
        //   type: 'error',
        //   message: '网络有点小问题...请刷新'
        // })
        console.log(error, info)
        console.log('当前身份不合法,请刷新')
        reject(false)
      }
    )
  })
  return promiseInstance
}


/**
 * 添加消息监听
 * @param type
 * @param func
 */
function addEventListener(type, func) {
  eventHub.$on(type, func)
}

/**
 * 移除消息监听
 * @param type
 * @param func
 */
function removeEventListener(type, func) {
  eventHub.$off(type, func)
}

function stop() {
  // TODO finish stop function
  webim.logout(function(resp) {
    eventHub.$emit(EVENT_TYPE.LOGOUT, resp)
  })
}


const txim = {
  getInstance,
  stop,
  // sendMessage,
  addEventListener,
  removeEventListener,
  EVENT_TYPE,
  ACTION_TYPE,
  MESSAGE_TYPE
}

// public
export default txim



// WEBPACK FOOTER //
// ./src/store/modules/call-center/im-tx.js